import { InjectionToken, inject, type StaticProvider } from '@angular/core';
import type { CacheSettings } from '@hyundai/shared-lib';

export const CACHE_SETTINGS = new InjectionToken<CacheSettings>('CACHE_SETTINGS');

export function provideCacheSettings(settings: CacheSettings): StaticProvider {
    return {
        provide: CACHE_SETTINGS,
        useValue: settings,
    };
}

export function injectCacheSettings(): CacheSettings | null {
    return inject(CACHE_SETTINGS, { optional: true });
}
